<div class="container">
  <div class="jumbotron text-center">
    <mat-icon>lock_outlined</mat-icon>
    <h1>Tasks De-Activated</h1>
    <p>Your tasks portal is currently de-activated. If you have any questions, please contact your Client Operations Lead.</p>
  </div>
</div>

